import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {GenericPopoutFilter, GeospatialFilterSettings} from '@core/interfaces/common/popout';
import {GeospatialViewerControlsApi} from './geospatial-viewer-controls.api';
import {GeospatialViewerConfiguration, GeospatialMetricsConfiguration} from '../model/viewer-config';
import {
    APIResponse,
    FilterFieldOption,
    FilterFieldType,
    FilterOperatorOption,
} from '@core/interfaces/system/system-common';
import {map} from 'rxjs/operators';

export interface OutageFilterGroup {
    groupKey: string;
    groupLabel: string;
    order: number;
    sectionFilterMethod: SectionFilterMethodEnum;
    // SectionFilterMethodEnum.GENERIC_FILTERS must provide the filters property
    filters?: GenericPopoutFilter[];
    // SectionFilterMethodEnum.NUMERIC_BUILDER must provide the metricFilterGroups property
    metricFilterGroups?: MetricFilterGroups;
}
export interface MetricFilterGroups {
    metricGroups: MetricGroup[];
    operators: FilterOperatorOption[]; // key will be FilterOperator but as a string
}
export interface MetricGroup {
    groupKey: string;
    groupLabel: string;
    metrics: MetricBuilderFilter[];
}
export interface MetricBuilderFilter {
    fieldKey: string;
    fieldName: string;
    fieldType: FilterFieldType;
    min: object;
    max: object;
}

export enum SectionFilterMethodEnum {
    GENERIC_FILTERS = 'GENERIC_FILTERS',
    NUMERIC_BUILDER = 'NUMERIC_BUILDER',
}

@Injectable()
export class GeospatialViewerControlsService {
    constructor(private api: GeospatialViewerControlsApi) {}

    /*
     * Configuration
     */
    // Overall module
    public getGeospatialViewerConfiguration(): Observable<GeospatialViewerConfiguration> {
        return this.api.getGeospatialViewerConfiguration();
    }

    // Metric layer config
    public getMetricConfig(workflowItemId: number): Observable<GeospatialMetricsConfiguration> {
        return this.api.getMetricConfig(workflowItemId);
    }

    /*
     * Filters
     */
    // Metric layer
    public getSpatialFilterSettings(): Observable<GeospatialFilterSettings> {
        return this.api.getGeospatialFilterSettings();
    }

    public getFilterFieldOptions(
        workflowItemId: number,
        fieldKey: string,
        limit?: number,
        search?: string,
        filters?: any[],
    ): Observable<APIResponse<FilterFieldOption[]>> {
        return this.api.getFilterFieldOptions(workflowItemId, fieldKey, limit, search, filters);
    }

    // Outage layer
    public getFilterOutageSettings(): Observable<OutageFilterGroup[]> {
        return this.api
            .getFilterConfigForOutageLayer()
            .pipe(map((res: APIResponse<OutageFilterGroup[]>) => res.response));
    }
}
